<i-title [buttons]="titleButtons" [text]="'valves.historic.title' | translate" [hasBackIcon]="true" (iconClick)="back()"></i-title>

@if (!loading) {
    <i-table
        [items]="items"
        [columns]="columns"
        [showAdvancedSearchBtn]="false"
        [search]="false"
        [multiselect]="false"
        [rows]="valveService.currentHistoricalPagination.pageSize || 50"
        [totalRecords]="valveService.currentHistoricalPagination.totalCount || 50"
        [first]="valveService.currentHistoricalPagination.pageNumber || 1"
        [loading]="tableLoading"
        [lazy]="true"
        [height]="'80vh'"
        (onLazyLoad)="onTableUpdate($event)"
    ></i-table>
} @else {
    <div class="loader">
        <i-loader></i-loader>
    </div>
}
